import { Form, Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import {
  DarkBlue,
  DarkBlueHover,
  DarkRedHover,
  Red,
} from '../../../../assets/colors'
import Button from '../../../../components/Button'
import FormField from '../../../../components/Form/FormField'
import Modal from '../../../../components/Modal'
import * as S from '../../../../components/ModalRemoveBatch/styles'

const ModalDeleteBatchFractionable = ({
  deleteObject,
  deleteAction,
  cancelAction,
}) => {
  const title = 'Deseja cancelar o fracionamento desse lote ?'

  const closeModal = () => {
    cancelAction()
  }

  return (
    <Modal
      show={deleteObject !== undefined}
      closedButton={false}
      title={title}
      body={(
        <Formik
          initialValues={{
            badgeUser: undefined,
          }}
          validationSchema={Yup.object().shape({
            badgeUser: Yup.string().required('form.required'),
          })}
          onSubmit={(values, { setSubmitting, setFieldError }) => {
            deleteAction(values.badgeUser)
              .then(() => {
                closeModal()
              })
              .catch((error) => {
                if (error?.response) {
                  const { message } = error?.response.data

                  setFieldError('badgeUser', message)
                } else {
                  setFieldError('badgeUser', 'Não foi possivel cancelar o lote')
                }
              })
              .finally(() => {
                setSubmitting(false)
              })
          }}
        >
          {({ isSubmitting, handleSubmit }) => (
            <Form style={{ padding: '0 20px 20px 20px' }}>
              <S.ModalBody>
                <S.ModalBody>
                  <FormField
                    label='badge.inspector'
                    name='badgeUser'
                    fieldType='password'
                  />
                </S.ModalBody>
                <S.UL>
                  <S.LI>
                    <S.ListItem
                      label='Lote ID: '
                      description={<b>{deleteObject?.id_lote}</b>}
                    />
                  </S.LI>
                  <S.LI>
                    <S.ListItem
                      label='Status: '
                      description={deleteObject?.status_fracionamento}
                    />
                  </S.LI>
                  <S.LI>
                    <S.ListItem
                      label='Fornecedor: '
                      description={deleteObject?.nome_fornecedor}
                    />
                  </S.LI>
                  <S.LI>
                    <S.ListItem
                      label='Cod. Produto: '
                      description={deleteObject?.cod_produto}
                    />
                  </S.LI>
                  <S.LI>
                    <S.ListItem
                      label='Descrição Produto: '
                      description={deleteObject?.descricao}
                    />
                  </S.LI>
                  <S.LI>
                    <S.ListItem
                      label='Qtd. Total: '
                      description={deleteObject?.quantidade_total}
                    />
                  </S.LI>
                  <S.LI>
                    <S.ListItem
                      label='Qtd. Util: '
                      description={deleteObject?.quantidade_util}
                    />
                  </S.LI>
                  <S.LI>
                    <S.ListItem
                      label='Qtd. Rejeitada: '
                      description={deleteObject?.quantidade_rejeitada}
                    />
                  </S.LI>
                </S.UL>
              </S.ModalBody>
              <S.ModalFooter>
                <Button
                  text='Excluir'
                  type='button'
                  style={{
                    marginRight: '5px',
                    height: '45px',
                    width: '150px',
                    padding: 0,
                    margin: 0,
                  }}
                  onClick={handleSubmit}
                  color={Red}
                  hoverColor={DarkRedHover}
                  isDisabled={isSubmitting}
                />

                <Button
                  text='Cancelar'
                  onClick={closeModal}
                  style={{
                    marginRight: '5px',
                    height: '45px',
                    width: '150px',
                    padding: 0,
                    margin: 0,
                  }}
                  color={DarkBlue}
                  hoverColor={DarkBlueHover}
                  isDisabled={isSubmitting}
                />
              </S.ModalFooter>
            </Form>
          )}
        </Formik>
      )}
    />
  )
}

export default ModalDeleteBatchFractionable
